import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
const _RequestBodySchema = z.object({});
const Response = z.object({
    success: z.boolean(),
});
export const url = (personId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/identity/authentication/person/${personId}/2fa/confirm`
        : `https://middleware.uat.farther.com/identity/authentication/person/${personId}/2fa/confirm`;
};
export default async function postMFAConfirm(personId, config) {
    const idemKey = `${new Date().toISOString()}-${personId}-confirmMFA`;
    const { data } = await axios.post(url(personId), {}, {
        headers: {
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
            Authorization: `Bearer ${config.jwt}`,
            Version: "20240529",
            "idempotency-key": idemKey,
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[postMFAConfirm] Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=postMFAConfirm.js.map